import { graphql } from '@/gql';
import type { MarkRideMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const markRide = async ({ description, rideId, requestId, status }: MarkRideMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      description,
      rideId,
      requestId,
      status,
    },
    mutation: graphql(`
      mutation MarkRide($description: String, $rideId: String, $requestId: String, $status: String!) {
        markRide(description: $description, rideId: $rideId, requestId: $requestId, status: $status) {
          id
        }
      }
    `),
  });

  return !!response.data?.markRide;
};
